import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.config.productionTip = false

function pixel() {
  loadScriptAsync('https://vk.com/js/api/openapi.js?168', 'text/javascript', onloadScript)
}

function onloadScript() {
  window.VK.Retargeting.Init("VK-RTRG-494681-8uMab")
  window.VK.Retargeting.Hit()
}

function loadScriptAsync(src, type, fun) {
  let script = document.createElement('script')
  script.src = src
  script.type = type
  script.async = true
  document.body.append(script)
  script.onload = fun
}

pixel()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueYandexMetrika, {
    id: 64604905,
    router: router,
    env: process.env.NODE_ENV
})